// extracted by mini-css-extract-plugin
export var editButton = "_jr-0";